













import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import PopupNotification from '@/modules/common/layout/components/shared/notification/PopupNotification.vue'
import { Notification } from '@/modules/notification/classes/notification'
import anime from 'animejs'

type PropTypes = {
  message: string,
  type: string
}

@Component({
  components: { PopupNotification }
})
export default class PopupNotificationGlobal extends Vue {
  active = false
  message = ''
  type = ''
  timeoutId: any = null

  beforeEnter(el: HTMLDivElement) {
    anime.set(el, {
      translateX: -500
    })
  }

  enter(el: HTMLDivElement, done) {
    anime({
      targets: el,
      translateX: 0,
      easing: 'easeInOutElastic',
      complete: done
    })
  }

  leave(el: HTMLDivElement, done) {
    anime({
      targets: el,
      translateX: -500,
      easing: 'easeInOutElastic',
      complete: done
    })
  }

  show(props: PropTypes) {
    this.message = props.message
    this.type = props.type
    this.active = true
  }

  hide() {
    this.active = false
    this.type = ''
    this.message = ''
  }

  handler(props: PropTypes) {
    if (this.active) {
      clearTimeout(this.timeoutId)

      this.show(props)

      this.timeoutId = setTimeout(() => {
        this.hide()
      }, 5000)

    } else {
      this.show(props)

      this.timeoutId = setTimeout(() => {
        this.hide()
      }, 5000)
    }
  }

  created() {
    Notification
      .listen(this.handler)
  }
}
